import React from "react";

function AscendingIcon({ isActive }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="14"
      viewBox="0 0 7 14"
      fill="none"
    >
      <path
        d="M2.287 4.73786L2.287 13.5319C2.28727 13.6245 2.32426 13.7133 2.38987 13.7787C2.45548 13.8441 2.54435 13.8809 2.637 13.8809H4.268C4.36048 13.8806 4.4491 13.8437 4.51449 13.7783C4.57988 13.713 4.61674 13.6243 4.617 13.5319L4.617 4.73786H5.959C6.09696 4.73728 6.23167 4.69595 6.34622 4.61906C6.46076 4.54216 6.55003 4.43314 6.60281 4.30567C6.65559 4.17821 6.66953 4.03799 6.64288 3.90263C6.61622 3.76727 6.55017 3.6428 6.453 3.54486L3.947 1.03886C3.81581 0.908179 3.63818 0.834807 3.453 0.834807C3.26783 0.834807 3.0902 0.908179 2.959 1.03886L0.453002 3.54486C0.355838 3.6428 0.28978 3.76727 0.263126 3.90263C0.236472 4.03799 0.250412 4.17821 0.303192 4.30567C0.355973 4.43314 0.445242 4.54216 0.559786 4.61906C0.674331 4.69595 0.809043 4.73728 0.947002 4.73786H2.287Z"
        fill={`${isActive ? "#2F5E8A" : "#9497A9"}`}
      />
    </svg>
  );
}

export default AscendingIcon;
